import { React, useState } from 'react';
import {
    createStyles,
    Text,
    Avatar,
    Group,
    TypographyStylesProvider,
    Paper,
    Textarea,
    Button,
    Card,
    Tabs,
    Image
} from '@mantine/core';
import{
    IconGavel,
    IconMessage,
    IconFileReport,
    IconArticle,
    IconNotes
} from '@tabler/icons';
import koenigsegg from '../assets/koenigsegg.jpg';
import pagani from '../assets/pagani.jpg';
import mustangs_rear from '../assets/mustangs_rear.jpg';
import porsche from '../assets/porsche.jpg';
import thunderbird_tail_light from '../assets/thunderbird_tail_light.jpg';
import black_and_white_mercedes_benz from '../assets/black_and_white_mercedes_benz.jpg';



const useStyles = createStyles((theme) => ({
    comment: {
        padding: `${theme.spacing.lg}px ${theme.spacing.xl}px`,
        //width: "inherit"
    },
    defPadding: {
        padding: "8px"
    },
    commentBtn: {
        marginLeft: "4%",
        marginBottom: "3%",
        
    },
    body: {
        paddingLeft: 54,
        paddingTop: theme.spacing.sm,
        fontSize: theme.fontSizes.sm,
    },
    displayArea: {
        width: "85%",
        margin: "0 auto"
    },
    panelArea: {
        //alignContent: "center",
        margin: "0 auto",
        alignItems: 'center',
    },

    content: {
        '& > p:last-child': {
            marginBottom: 0,
        },
    },
}));

let authHold = {
    src: koenigsegg,
    name: "John Does"
}
const articleTmp = [
    {
        src: koenigsegg,
        descript: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nulla tellus nisi, posuere in dui non, tristique consequat risus. Maecenas malesuada risus nulla, nec efficitur nunc auctor sed. Duis vulputate tortor turpis, at cursus magna luctus vitae. Nam venenatis magna id magna blandit, id pharetra diam vehicula. Pellentesque non leo scelerisque nisi pretium aliquam sollicitudin ut dui. Proin dapibus augue quis ligula sagittis elementum. Curabitur ac ipsum id mi vulputate suscipit aliquet sed arcu. Nam tempor tortor quis urna feugiat, sed interdum turpis facilisis. In id rutrum sapien. Donec at arcu lectus. Sed vitae porttitor purus, in auctor neque.',
        title: 'Section A'
    },
    {
        src: pagani,
        descript: 'Phasellus sit amet elit condimentum, sodales justo quis, dictum leo. Suspendisse rhoncus varius ipsum, quis efficitur magna congue pulvinar. Nunc sed mauris eget arcu laoreet elementum ut ut sem. Maecenas dignissim erat ultrices ante pretium porttitor. Praesent congue imperdiet porttitor. Aenean id euismod lacus, eget convallis augue. Nam condimentum dui vel pellentesque volutpat. Fusce velit urna, ultricies a est in, aliquet congue elit.',
        title: 'Section B'
    },
    {
        src: mustangs_rear,
        descript: 'Vestibulum dignissim leo at nisl iaculis, non iaculis nibh elementum. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Sed gravida sed enim nec auctor. Cras venenatis diam a hendrerit semper. Pellentesque scelerisque dolor et ipsum fringilla accumsan. Pellentesque diam dui, vehicula id pharetra ultrices, lacinia nec ligula. Nam aliquet pellentesque sem at volutpat. Nam volutpat congue mauris et fringilla. Proin eleifend lacus a felis tristique vestibulum. Mauris congue elit vel erat malesuada auctor.',
        title: 'Section C'
    },
    {
        src: porsche,
        descript: 'Sed consequat vestibulum enim, luctus ornare tortor. Vivamus a lacinia risus. Nulla vehicula enim sed lacinia molestie. Suspendisse eget porta enim. Nullam facilisis dapibus tristique. Sed fermentum ipsum turpis, et accumsan justo venenatis at. Fusce dolor eros, tincidunt eu maximus sit amet, posuere sed metus. Quisque ultricies at lacus vitae maximus. Nam eu ipsum molestie, commodo mi eget, ultrices arcu. Donec scelerisque lorem vel eleifend malesuada. Phasellus faucibus viverra tellus a consequat. Fusce rutrum pellentesque varius. Phasellus sem augue, laoreet ac tellus in, aliquet lobortis ligula. Praesent ut arcu nibh. Duis sodales iaculis neque ac iaculis.',
        title: 'Section D'
    },
    {
        src: thunderbird_tail_light,
        descript: 'Nulla sagittis gravida mi ut mollis. Nulla feugiat, sapien nec convallis facilisis, massa dolor suscipit ante, porta egestas mauris risus eget quam. Cras orci tellus, interdum sed maximus quis, mollis at metus. Sed vel tincidunt nisl, eu sagittis ipsum. Fusce quis viverra leo, in semper dolor. Ut in volutpat sem, sit amet vulputate erat. Etiam accumsan id nulla quis eleifend. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Nulla at elit et lectus lobortis tempus ac id ex. Sed nec odio lectus. Morbi enim arcu, tincidunt non neque feugiat, dignissim tristique diam. Duis sed tristique erat.',
        title: 'Section E'
    },
    {
        src: black_and_white_mercedes_benz,
        descript: 'Etiam convallis nibh massa, id accumsan tortor molestie tristique. Proin ut auctor dolor, in fringilla enim. Aliquam suscipit velit ut neque faucibus ullamcorper. Nam ex tortor, luctus ut nisl ac, eleifend tempor massa. Quisque a leo sodales, venenatis quam aliquet, hendrerit nisl. Nullam mattis elit id nisi ornare molestie. Mauris non tortor ultrices, venenatis velit eu, interdum tortor.',
        title: 'Section F'
    },
];

//needed: props 
/*
 * article_items_2_6
 *      - src_0
 *      - descript_0
 *      - title_0
 * */
export function CarCardDetsArticle() {
    const { classes } = useStyles();
    
    
    //needed: different way of mapping this bc 
    const articleVal = articleTmp.map((articleItm, index) => 
        <>
            <h3>
            {articleItm.title}
            </h3>
            <br/>
            <Image src={articleItm.src} width={"95%"}/>
            <br/>
            <Text>
            {articleItm.descript}
            </Text>
        </>
        
    )
    
    return (
        <>
            {articleVal}
        </>
    );
}
